import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import Popover from '@material-ui/core/Popover';
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {Typography, InputLabel,FormControl,Paper} from '@material-ui/core';
////////Icono INFORMACION////////////////
const Informacion ='/informacion.svg'
////////Estilos/////////
const useStyles = makeStyles((theme) => ({
    icono: {
        width: "99%",
        position: "absolute",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    },
}));

export default function HelpInput(props) {
    const classes = useStyles();
/////////estados para el popover devEUI//////
const [anchorEl, setAnchorEl] = React.useState(null);

const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
};

const handleClose = () => {
    setAnchorEl(null);
};

const open = Boolean(anchorEl);
const id = open ? 'simple-popover' : undefined;
//////////fin estados popover devEUI///////

    return (
        <div >
            <IconButton
            aria-label="toggle email visibility"
            onClick={handleClick}
            edge="end"
            >
                <img src={Informacion} style={{ width: "20px", height: "20px" }} />
            </IconButton>
            <Popover
            id="mouse-over-popover"
            className={classes.popover}
            classes={{
                paper: classes.paper2,
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            onClose={handleClose}
            disableRestoreFocus
            
            >
            <Typography style={{padding:"5px"}}>{props.help}</Typography>
            </Popover>
    </div>
    );
}
